import React from "react";
import { useNavigate } from "react-router-dom";
import "./TalentPoolPage.css";

export default function TalentPoolPage() {
  const navigate = useNavigate();

  return (
    <div className="talent-pool-page">

      <h1 className="talent-pool-title">Talent Pool Management</h1>

      <div className="talent-pool-buttons">

        <button
          className="talent-btn"
          onClick={() => navigate("/admin-panel/pending-talents")}
        >
          Pending Talent Registration
        </button>

        <button
          className="talent-btn"
          onClick={() => navigate("/admin-panel/approved-talents")}
        >
          Current Talent Pool
        </button>

        <button
          className="talent-btn"
          onClick={() => navigate("/admin-panel/rejected-talents")}
        >
          Rejected Talent Registration
        </button>

      </div>
    </div>
  );
}